import styled from '@emotion/styled';
import { style } from '../../../../components/Shared/Style';

export default styled.p({
    margin: '0',
    width: '160px',
    color: style.colors.secondary
});
